import { SystemStyleObject } from "@chakra-ui/react";

export const dropdownButtonCss: SystemStyleObject = {
  height: "28px",
  borderRadius: "8px",
  padding: "4px 16px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 0px 0px 1px #122B6914",
  fontWeight: 600,
  color: "#4A5564",
  fontSize: "14px",
  lineHeight: "20px",
};
